var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.element, { tag: "component", staticClass: "vsm-menu" }, [
    _c("nav", { staticClass: "primary-nav-region" }, [
      _c("div", { staticClass: "primary-nav-inner" }, [
        _c(
          "ul",
          {
            ref: "root",
            staticClass: "vsm-root vsm-list",
            class: _vm.menuAlignmentDisplay,
          },
          [
            _vm._l(_vm.menu, function (item, index) {
              return _c(
                "li",
                {
                  key: `mega-menu-${item.id}-${index}`,
                  staticClass:
                    "vsm-list-item vsm-section vsm-section_menu vsm-mob-hide",
                },
                [
                  _c(
                    _vm.menuBlockComponent(item),
                    _vm._g(
                      _vm._b(
                        {
                          ref: "links",
                          refInFor: true,
                          tag: "component",
                          class: [
                            "vsm-link",
                            item.attributes ? item.attributes.class : null,
                            { "vsm-has-dropdown": item.linkMegaMenu },
                          ],
                          attrs: {
                            "data-dropdown": item.id,
                            "aria-haspopup": item.linkMegaMenu && true,
                            "aria-expanded": item.linkMegaMenu && false,
                            tabindex: "0",
                            href:
                              !item.element && !item.linkMegaMenu
                                ? item.linkUrl
                                : false,
                            to: {
                              path:
                                !item.element && !item.linkMegaMenu
                                  ? item.linkUrl
                                  : false,
                            },
                            target:
                              !item.element && !item.linkMegaMenu
                                ? item.linkTarget
                                : false,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeDropdown.apply(null, arguments)
                            },
                          },
                        },
                        "component",
                        item.attributes,
                        false
                      ),
                      item.listeners
                    ),
                    [
                      _vm._t(
                        "title",
                        function () {
                          return [_c("span", [_vm._v(_vm._s(item.linkText))])]
                        },
                        { item: item, index: index, onClose: _vm.closeDropdown }
                      ),
                      _vm._v(" "),
                      item.linkMegaMenu
                        ? [
                            _vm._t("mobile-icon"),
                            _vm._v(" "),
                            _vm._t("dropdown-icon"),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._t("after-nav"),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vsm-dropdown vsm-mob-hide" }, [
      _c(
        "div",
        { ref: "dropdownContainer", staticClass: "vsm-dropdown-container" },
        _vm._l(_vm.menuHasDropdown, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              ref: "sections",
              refInFor: true,
              staticClass: "vsm-dropdown-section",
              attrs: { "data-dropdown": item.id, "aria-hidden": "false" },
            },
            [
              _c(
                "div",
                { staticClass: "vsm-dropdown-content" },
                [
                  _c("div", { staticClass: "vsm-dropdown-header" }, [
                    _c("h4", { staticClass: "title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.linkText) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("button", { on: { click: _vm.closeDropdown } }, [
                      _vm._v("\n              Close\n            "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._t("default", null, {
                    item: item,
                    index: index,
                    onClose: _vm.closeDropdown,
                  }),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { ref: "background", staticClass: "vsm-background" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }